<template>
  <div class="icon-component" :style="[{height: height + '!important'},{width: width + '!important'}]">
    <div v-if="getIconNames === getIconNames.toUpperCase()" class="icon" :class="{'icon-hover': cursorPointer}"
         :style="[{'-webkit-mask-image': 'url(' + imagePath(getIconNames, iconType)+')'},
               {'mask-image': 'url(' + imagePath(getIconNames, iconType)+')'},{width: width},
               {height: height},{backgroundColor: colorCode || getColors[color] || getColors.primary}]"></div>

    <font-awesome-icon v-else
                       :key="iconRenderKey"
                       :icon="[`fa${getIconWeight}`, getIconNames]"
                       :style="{
                         fontSize: width,
                         color: colorCode || getColors[color] || getColors.primary
                       }"/>
  </div>
</template>

<script>
import {hasIcon, loadMissingIcon} from '@/plugins/fontawesome'
import {mapGetters} from 'vuex'
export default {
  name: 'customIcon',
  props: {
    width: {
      type: String,
      default: '2rem'
    },
    height: {
      type: String,
      default: '2.2rem'
    },
    icon: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: 'svg',
      validator (value) {
        return ['svg', 'png', 'jpg', 'jpeg', 'webp'].includes(value)
      }
    },
    iconWeight: {
      type: String,
      default: 'light',
      validator (value) {
        return ['light', 'regular', 'solid', 'duotone', 'kit'].includes(value)
      }
    },
    color: {
      type: String,
      default: () => {
        return 'primary'
      },
      validator (value) {
        if (value) {
          return ['success', 'danger', 'warning', 'gray', 'dark-gray', 'primary', 'purple', 'info', 'white'].includes(value || 'success')
        } else {
          return true
        }
      }
    },
    colorCode: {
      type: String,
      default: () => {
        return ''
      }
    },
    cursorPointer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      iconRenderKey: 0,
      colors: {
        'primary': '#197ed5',
        'success': '#28c76f',
        'warning': '#ffa146',
        'danger': '#ea5455',
        'purple': '#b93f91',
        'info': '#7c45d9',
        'gray': '#cecece',
        'dark-gray': '#626262',
        'white': '#ffffff'
      }
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    }),
    getColors () {
      const colors = {
        ...this.colors,
        'primary': this.isMobile ? '#3b6ef5' : '#197ed5',
        'success': this.isMobile ? '#34a853' : '#28c76f',
        'warning': this.isMobile ? '#ff9f43' : '#ffa146',
        'danger': this.isMobile ? '#fe4444' : '#ea5455',
        'purple': '#b93f91',
        'gray': '#cecece',
        'dark-gray': '#626262',
        'white': '#ffffff'
      }

      return colors
    },
    getIconNames () {
      switch (this.icon) {
      case 'plus-icon':
        return 'plus-large'

      case 'edit-icon':
        return 'pen-line'

      case 'save-icon':
        return 'floppy-disk'

      case 'print-icon':
        return 'print'

      case 'list-icon':
        return 'list-check'

      case 'setting-icon':
        return 'gear'

      case 'trash-icon':
        return 'trash-can'

      case 'bin-recycle-icon':
        return 'trash-can'

      default:
        return this.icon.replace('-icon', '')
      }
    },
    getIconWeight () {
      switch (this.getIconNames) {
      case 'solid-cart-shopping-rotate':
      case 'regular-cart-shopping-rotate':
      case 'solid-bag-shopping-rotate':
      case 'regular-bag-shopping-rotate':
      case 'regular-bag-shopping-location-pin':
      case 'regular-bag-shopping-globe':
      case 'regular-bag-shopping-circle-ellipsis':
      case 'regular-cart-shopping-location-pin':
      case 'regular-cart-shopping-globe':
      case 'regular-cart-shopping-circle-ellipsis':
      case 'regular-arrow-up-right-dots-circle-plus':
      case 'regular-arrow-up-right-dots-location-pin':
      case 'regular-arrow-up-right-dots-globe':
        return 'k'

      default:
        switch (this.iconWeight) {
        case 'light':
        case 'solid':
        case 'regular':
        case 'duotone':
        case 'kit':
          return this.iconWeight[0]
        }
      }
    }
  },
  watch: {
    getIconNames: {
      handler: 'loadIconIfMissing',
      immediate: true
    },
    getIconWeight: 'loadIconIfMissing'
  },
  methods: {
    loadIconIfMissing () {
      const iconName = this.getIconNames
      const prefix = `fa${this.getIconWeight}`
      if (!iconName || iconName === iconName.toUpperCase() || hasIcon(prefix, iconName)) return

      loadMissingIcon(prefix, iconName).then(found => {
        // re-render font-awesome-icon, the icon library is not reactive
        if (found && iconName === this.getIconNames) this.iconRenderKey++
      })
    },
    imagePath (name, type) {
      return require(`@/assets/icons/${  name  }.${  type}`)
    }
  }
}
</script>

<style lang="scss" scoped>

div.icon-component {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    display: inline-block;
    background-size: cover;
    mask-position: center !important;
    -webkit-mask-position: center !important;
    mask-repeat: no-repeat !important;
    margin: auto !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &.icon-hover {

      &:hover, &:focus {
        cursor: pointer;
        filter: invert(27%) sepia(5%) hue-rotate(10deg) brightness(100%) contrast(90%);
      }
    }
  }
}

@supports (-webkit-touch-callout: none) {
  /* CSS specific to iOS devices */
  @media print {
    .icon-component {
      .icon {
        background-color: unset !important;
      }
    }
  }
}

</style>
